
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface ProfileHeaderProps {
  handleGoBack: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ handleGoBack }) => {
  return (
    <div className="flex items-center mb-6">
      <Button 
        variant="outline" 
        className="mr-4 border-[#0EA5E9]/30 text-[#0EA5E9] hover:bg-[#0EA5E9]/10"
        onClick={handleGoBack}
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Dashboard
      </Button>
      <h1 className="text-3xl font-bold text-gray-800">My Profile</h1>
    </div>
  );
};

export default ProfileHeader;
